/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$third-level-navigation-tab-height: 68px !default;
$third-level-navigation-tab-height-mobile: 48px !default;
$third-level-navigation-tab-border-width: 4px !default;
$third-level-navigation-tab-padding: 24px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$gradient-width: 48px;

@mixin setGradientsBackground($color) {
  .#{$prefix}scroll-window.#{$prefix}gradient-left::before {
    background: linear-gradient(90deg, rgb($color) 0%, rgba($color, 0) 100%);
  }

  .#{$prefix}scroll-window.#{$prefix}gradient-right::after {
    background: linear-gradient(90deg, rgba($color, 0) 0%, rgb($color) 100%);
  }
}

:host {
  display: block;
  box-sizing: border-box;
  overflow: visible;
}

.#{$prefix}nav-items-wrapper {
  width: 100%;
  max-width: $content-max-width-desktop-l;
  margin: 0 auto;

  @include for-size(desktop-or-smaller) {
    max-width: $content-max-width-desktop;
  }
}

.#{$prefix}nav-items {
  position: relative;
  display: flex;
  align-items: center;
  height: $third-level-navigation-tab-height;

  @include setGradientsBackground(var(--overflowGradientColor));

  @include for-size(phone) {
    height: $third-level-navigation-tab-height-mobile;
  }

  // This is the underline embracing all navigation items. We use ::before because we need
  // the content to overlap the underline. (e.g. the active border of CTA)
  &::before {
    position: absolute;
    left: 0;
    bottom: 0;

    content: "";
    width: 100%;
    height: $third-level-navigation-tab-border-width;
    background-color: var(--tabBorderColor);
  }

  .#{$prefix}scroll-window {
    position: relative;

    overflow: hidden;
    flex-grow: 1;
    flex-shrink: 1;

    &.#{$prefix}gradient-left::before {
      position: absolute;
      top: 0;
      left: 0;
      bottom: $third-level-navigation-tab-border-width;
      z-index: 11;

      content: "";
      width: $gradient-width;
    }

    &.#{$prefix}gradient-right::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: $third-level-navigation-tab-border-width;
      z-index: 11;

      content: "";
      width: $gradient-width;
    }

    .#{$prefix}scroll-wrapper {
      display: flex;
      // position: absolute;
      position: relative;
      height: $third-level-navigation-tab-height;
      z-index: 10;
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      } //hide scrollbar for chrome
      overflow: -moz-scrollbars-none; //hide scrollbar for mozilla
      -ms-overflow-style: none; //hide scrollbar for internet explorer
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;

      @include for-size(phone) {
        height: $third-level-navigation-tab-height-mobile;
      }

      .#{$prefix}highlight-border {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 0;
        height: $third-level-navigation-tab-border-width;
        background-color: v(tabActiveBorderColor);
        transition: all 250ms $transition-timing-function 0s;
      }
    }
  }

  .#{$prefix}cta-wrapper {
    // We position the CTa relatively so its active border appears on top of the ::before item
    // which is the big underline.
    position: relative;

    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    // Spacing set by the child to avoid empty wrapper with space.
    > * {
      margin-right: 16px;
      margin-left: 8px;
    }

    .#{$prefix}icon-button,
    .#{$prefix}icon-link {
      display: none;
    }

    @include for-size(phone) {
      .#{$prefix}icon-button,
      .#{$prefix}icon-link {
        display: initial;
      }

      .#{$prefix}text-button,
      .#{$prefix}text-link {
        display: none;
      }
    }
  }
}
